/** Evento disparado por main.tsx quando uma versão nova chega com o app em uso. */
export const EVENTO_ATUALIZACAO = "glucofy:atualizacao";
